function engraveComponent(initialData) {
    return {
        text: initialData.text || '',
        font: initialData.font || '',
        moduleInitialized: false,
        updateFont(font) {
            this.$root.engraveModule.setFontFamily(font).update();
        },
        insertSymbol(symbol) {
            const { engraveTextElement } = this.$refs;

            if (
                engraveTextElement.value.length >=
                Number(engraveTextElement.getAttribute('maxlength'))
            ) {
                return;
            }

            const [start, end] = [
                engraveTextElement.selectionStart,
                engraveTextElement.selectionEnd,
            ];

            engraveTextElement.setRangeText(symbol, start, end, 'end');
            engraveTextElement.dispatchEvent(new Event('input'));
        },
        init() {
            this.$refs.engraveModuleContainer.addEventListener('shown.bs.collapse', () => {
                if (!this.moduleInitialized) {
                    this.initEngraveModule();
                    this.moduleInitialized = true;
                }
            });

            window.Livewire.on('wedding-set-changed', () => {
                const collapseInstance = window.bootstrap.Collapse.getInstance(
                    this.$refs.engraveModuleContainer
                );

                collapseInstance?.hide();
            });
        },
        async initEngraveModule() {
            const { PreviewSVG } = await import('@js/pages/product/engrave/engravePreview');

            const container = this.$root;

            const previewWrapper = container.querySelector('.engrave-preview-wrapper');

            const svgWrapper = container.querySelector('.engrave-preview-svg');
            const previewBgImg = container.querySelector('.js-engrave-preview-bg');

            const defaultFontElement = container.querySelector(`[value="${this.font}"]`);

            container.engraveModule = new PreviewSVG({
                wrapper: svgWrapper,
                width: previewWrapper.offsetWidth,
                height: previewWrapper.offsetHeight,
                edgesTop: previewWrapper.dataset.edgesTop,
                fontSize: previewWrapper.dataset.fontSize,
                fontFamily: defaultFontElement?.dataset.font || 'Anton',
                text: this.text,
            });

            previewBgImg.addEventListener('load', () => {
                container.engraveModule.setHeight(previewWrapper.offsetHeight);
                container.engraveModule.update();
            });

            let debounce = null;

            this.$watch('text', (value) => {
                container.engraveModule.setText(value).update();

                clearTimeout(debounce);
                debounce = setTimeout(() => {
                    this.$dispatch('engrave:textUpdated', {
                        name: this.$wire.name,
                        value,
                    });

                    if (!value) {
                        this.$dispatch('engrave:fontUpdated', {
                            name: this.$wire.font_option_name,
                            value: null,
                        });
                    } else {
                        this.$dispatch('engrave:fontUpdated', {
                            name: this.$wire.font_option_name,
                            value: this.font,
                        });
                    }
                }, 300);
            });

            this.$watch('font', (value) => {
                this.$dispatch('engrave:fontUpdated', {
                    name: this.$wire.font_option_name,
                    value,
                });
            });
        },
    };
}

window.engraveComponent = engraveComponent;
